import { render } from "./InvitationMessage.vue?vue&type=template&id=28bb1fb4&scoped=true"
import script from "./InvitationMessage.vue?vue&type=script&lang=js"
export * from "./InvitationMessage.vue?vue&type=script&lang=js"

import "./InvitationMessage.vue?vue&type=style&index=0&id=28bb1fb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bb1fb4"]])

export default __exports__